<form [formGroup]="jiraForm">
  <div class="dialog-container" style="height: 100%">
    <div class="dialog-top-row" style="height: 50%; display: flex; gap: 1rem">
      <div class="left-fields" style="width: 50%">
        <!-- Ticket Type -->
        <div class="dialog-field">
          <geaui-autocomplete-select-v3
            [formGroup]="jiraForm"
            [formFieldName]="'ticketType'"
            [required]="true"
            [floatLabelType]="'always'"
            [label]="'Ticket Type:'"
            [options]="ticketTypeOptions"
            [value]="jiraForm.get('ticketType')?.value"
            (valueChange)="onValueChange($event, 'ticketType')"
            [fieldError]="
              jiraForm.get('ticketType')?.value == null ? 'Required field' : ''
            "
          ></geaui-autocomplete-select-v3>
        </div>

        <!-- Sub Header -->
        <div class="dialog-field">
          <geaui-autocomplete-select-v3
            [formGroup]="jiraForm"
            [formFieldName]="'subHeader'"
            [floatLabelType]="'always'"
            [required]="true"
            [label]="'Sub Header:'"
            [placeholder]="'Select Sub Header'"
            [options]="subHeaderOptions"
            (valueChange)="onValueChange($event, 'subHeader')"
            [fieldError]="
              jiraForm.get('subHeader')?.value == null ? 'Required field' : ''
            "
          ></geaui-autocomplete-select-v3>
        </div>

        <!-- Company -->
        <div class="dialog-field">
          <geaui-multi-select-v3
            [formGroup]="jiraForm"
            [formControlName]="'company'"
            [floatLabelType]="'always'"
            [required]="true"
            [hideSearchbar]="true"
            [label]="'Company:'"
            [options]="companyOptions"
            [value]="jiraForm.get('company')?.value"
            [fieldError]="
              jiraForm.get('company')?.value == null ? 'Required field' : ''
            "
          ></geaui-multi-select-v3>
        </div>
      </div>

      <div class="right-fields" style="width: 50%">
        <!-- Priority -->
        <div class="dialog-field">
          <geaui-autocomplete-select-v3
            [formGroup]="jiraForm"
            [formFieldName]="'priority'"
            [floatLabelType]="'always'"
            [label]="'Priority:'"
            [placeholder]="'Select Priority'"
            [options]="priorityOptions"
            (valueChange)="onValueChange($event, 'priority')"
          ></geaui-autocomplete-select-v3>
        </div>
        <!-- Assign To -->
        <div class="dialog-field">
          <geaui-autocomplete-select-v3
            [formGroup]="jiraForm"
            [formFieldName]="'assignTo'"
            [floatLabelType]="'always'"
            [label]="'Assign To:'"
            [placeholder]="'Select User'"
            [loading]="isLoadingUsers"
            [disabled]="isFieldDisabled"
            [options]="assignToOptions"
            (valueChange)="onValueChange($event, 'assignTo')"
          ></geaui-autocomplete-select-v3>
        </div>

        <!-- Report To -->
        <div class="dialog-field">
          <geaui-autocomplete-select-v3
            [formGroup]="jiraForm"
            [formFieldName]="'reportTo'"
            [floatLabelType]="'always'"
            [label]="'Report To:'"
            [placeholder]="'Select User'"
            [loading]="isLoadingUsers"
            [disabled]="isFieldDisabled"
            [options]="reportToOptions"
            (valueChange)="onValueChange($event, 'reportTo')"
          ></geaui-autocomplete-select-v3>
        </div>
      </div>
    </div>
    <div class="dialog-bottom-row" style="height: 50%; width: 100%">
      <!-- Summary Label (Read-Only) -->
      <div class="dialog-field">
        <span style="color: var(--geaui-vibrant-blue)"
          ><strong>Ticket Title: {{ summaryLabel }}</strong></span
        >
      </div>

      <!-- Summary -->
      <div class="dialog-field">
        <geaui-textfield-v2
          label="Summary:"
          [required]="true"
          formControlName="summary"
          [floatLabelType]="'always'"
          initialValue="{{ jiraForm.get('summary')?.value }}"
          (valueChanged)="jiraForm.get('summary')?.setValue($event)"
          [showRequiredErrorWithoutSubmit]="true"
        ></geaui-textfield-v2>
      </div>

      <!-- Description -->
      <div class="dialog-field">
        <geaui-textfield-v2
          label="Description:"
          [required]="true"
          formControlName="description"
          [floatLabelType]="'always'"
          initialValue="{{ jiraForm.get('description')?.value }}"
          (valueChanged)="jiraForm.get('description')?.setValue($event)"
          [showRequiredErrorWithoutSubmit]="true"
        ></geaui-textfield-v2>
      </div>
    </div>
  </div>
</form>
